@if (Spinner.isShown('loading')) {
    <div fxLayout="column"
         class="w-100 h-100 mt-241"
         fxLayoutAlign="center center"
         fxFlex>
        <ui-kit-spinner spinnerIds="loading" [diameter]="40"/>
        @if (timeoutReached) {
            <div fxLayout="column" fxLayoutAlign="center center" class="w-100 pl-12 pr-12 mt-24">
                <div class="h3-semi-bold text-center c-primary-gray-900 pre-line">
                    {{ 'i18n_auth_livenessStateTitle_NETWORK_PROBLEM' | translate }}
                </div>
                <div class="t2 mt-24 pre-line text-center">
                    {{ 'i18n_auth_livenessStateSubtitle_NETWORK_PROBLEM' | translate }}
                </div>
            </div>
        }
        <ui-kit-error-panel class="mt-24" color="yellow" [errorWarningPanelTitle]="'i18n_auth_warningDisableVPN'"></ui-kit-error-panel>
    </div>
}
